module.exports = __webpack_public_path__ + "static/img/oil5.fe062b09.png";